import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import escapeRegExp from 'lodash/escapeRegExp';

import { useLagoon } from '../../../../hooks/useLagoon';
import { ConstantsLagoon } from '../../../ConstantsLagoon';
import { phoneOnly } from '../../../ConstantsStyles';
import { getFeatureFlag } from '../../../Utils';
import {
  SuggestionListItem,
  keywordSearchDropdownIconColor,
} from './KeywordSearchDropdown.styled';

type Props = {
  keywordSearchTerm: string;
  onClick: any;
};
export const UserTextSearch = ({ keywordSearchTerm, onClick }: Props) => {
  const escapedKeywordSearchTerm = escapeRegExp(keywordSearchTerm);
  const isPhone = useMediaQuery(phoneOnly);
  const featureFlags = useLagoon('feature-flags')();
  const userTextSearchEnabled: boolean = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.AUTOCOMPLETE_PARALLEL_SEARCHFLOW
  );

  type LagoonData = {
    key: string;
    value: string | number;
  };

  const getLagoonContent = (data: LagoonData[], key: string) =>
    data?.filter((row) => row?.key === key)[0]?.value || '';

  const lagoonTitleTable = useLagoon('typeahead-params')();
  const userQueryLabel = getLagoonContent(
    lagoonTitleTable,
    ConstantsLagoon.TYPEAHEAD_PARAMS.USER_TEXT_SEARCH_LABEL
  );

  if (userTextSearchEnabled) {
    return (
      <SuggestionListItem
        data-testid="user-text-search-common-suggestion"
        onClick={(ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          onClick(escapedKeywordSearchTerm);
        }}
        style={{ whiteSpace: isPhone ? '' : 'pre' }}
      >
        <span className="icon-span">
          <IconSymbol color={keywordSearchDropdownIconColor} icon="search" />
        </span>

        <Flex alignItems="center" style={{ flexWrap: 'wrap' }}>
          <Text
            color="$core.color.brand.60"
            fontSize="lg"
            style={{ marginRight: '8px' }}
          >
            {keywordSearchTerm}
            <Text color="$core.color.neutral.80" fontWeight="medium">
              {` - ${userQueryLabel}`}
            </Text>
          </Text>
        </Flex>
      </SuggestionListItem>
    );
  }
  return null;
};
